export default "__VITE_ASSET__2c35dd1c__"